import { marked } from 'marked'
import DOMPurify from 'dompurify'

marked.setOptions({
    gfm: true,
    tables: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    headerPrefix: 'cm'
})

/**
 * Turn markdown answer to html answer
 *
 * Mutates the answerPayload by reference
 *
 * @param {object} answerPayload
 */
export const parseAnswer = (answerPayload) => {
    if (answerPayload?.data?.answer) {
        answerPayload.data.answer = DOMPurify.sanitize(answerPayload.data.answer)

        answerPayload.data.answer = unescapeMarkdown(answerPayload.data.answer)

        answerPayload.data.answer = marked(answerPayload.data.answer)

        replaceMedia(answerPayload.data)
        replaceHyperlinks(answerPayload.data, answerPayload.metadata)
    }

    return answerPayload
}

/**
 * Unescapes markdown
 * @param {String} answer
 */
export const unescapeMarkdown = (answer) =>
    answer.replace(/^\\#/gm, '#').replace(/^\\>/gm, '>')

const replaceHyperlinks = (data, metadata) => {
    let answer = data.answer

    if (Array.isArray(data.links) && data.links.length > 0) {
        data.links.forEach((h) => {
            const pattern = new RegExp('%\\{Link\\(' + h.id + '\\)\\}', 'gi')
            const a = `<a href="${h.url}" target="${h.target}" data-url="${h.url}" data-id="${h.id}" data-interactionid="${metadata.interactionId}" data-dcx-link>${h.text}</a>`

            answer = answer.replace(pattern, a)
        })
    }

    data.answer = answer
}

/**
 * Replaces Images and Videos
 * @param {Object} data
 */
export const replaceMedia = (data) => {
    replaceImages(data)
    replaceVideos(data)
}

/**
 * Replaces images in answers
 * @param {Object} engineResult
 */
export const replaceImages = (data) => {
    if (Array.isArray(data.images)) {
        data.images.forEach((img) => {
            const additionalData = img.additionalData || {}

            // get the factor the image should be sized to
            const sizeFactor = additionalData.imageWidth
                ? parseFloat(img.additionalData.imageWidth)
                : 1

            // get the alignment class (left/center/right)
            const alignment = additionalData.imageAlign
                ? img.additionalData.imageAlign
                : 'left'

            // convert it to a percentage
            const imageWidth = sizeFactor * 100
            const url = img.name
            // replace the image tags in the content
            const pattern = new RegExp('%\\{Image\\(' + img.id + '\\)\\}', 'gi')
            const imgHtml = `<img src="${url}"
                            data-src="${url}"
                            title="${img.title || ''}"
                            alt="${img.title || ''}"
                            class="cxco-c-image  cxco-lightbox  ${alignment}"
                            width="${imageWidth}%" />`

            data.answer = data.answer.replace(pattern, imgHtml)
        })
    }
}

/**
 * Replaces the video placeholder by the actual video
 * @param {Object} data
 */
export const replaceVideos = (data) => {
    // default dimensions of a video
    const defaultHeight = 250

    if (Array.isArray(data.videos)) {
        data.videos.forEach((video) => {
            const additionalData = video.additionalData || {}

            // get the alignment class (left/center/right)
            const alignment = additionalData.videoAlign
                ? video.additionalData.videoAlign
                : 'left'

            // get the videoId
            const videoId = additionalData.videoId ? video.additionalData.videoId : ''

            // set the proper embed url based on the source
            let url = ''

            if (video.source.toLowerCase() === 'youtube') {
                url = 'https://www.youtube.com/embed/' + videoId
            } else if (video.source.toLowerCase() === 'youtubenocookie') {
                url = 'https://www.youtube-nocookie.com/embed/' + videoId
            } else if (video.source.toLowerCase() === 'vimeo') {
                url = 'https://player.vimeo.com/video/' + videoId
            }

            // replace the video tags in the content
            const pattern = new RegExp('%\\{Video\\(' + video.id + '\\)\\}', 'gi')
            const videoHtml = `<iframe src="${url}"
                                class="${alignment}"
                                style="height:${defaultHeight}px;width:${Number(additionalData.videoWidth) * 100
}%;"
                                frameborder="0"
                                allowfullscreen="allowfullscreen"
                                mozallowfullscreen="mozallowfullscreen" 
                                msallowfullscreen="msallowfullscreen" 
                                oallowfullscreen="oallowfullscreen" 
                                webkitallowfullscreen="webkitallowfullscreen"></iframe>`

            data.answer = data.answer.replace(pattern, videoHtml)
        })
    }
}
